import React, { useContext, useEffect } from "react";
import layoutContext from "../context/LayoutContext";

const useSmallNav = (text) => {
  const layout = useContext(layoutContext);

  useEffect(() => {
    layout.setSmallNavText(text);
  }, []);
};

export default useSmallNav;
